module.exports = __webpack_public_path__ + "static/peptide-d94cf2c33ae245a91934d8fb97f8455e.gif";